import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { View } from "@/components/ui/view";
import { Pressable } from "@/components/ui/pressable";
import { Image } from "@/components/ui/image";
import { Center } from "@/components/ui/center";
import React, { useState, useRef } from 'react';
import i18n from 'i18n-js';
import { Modal } from "react-native";
import { IconM, IconMC } from '../media/IconsV2';
import { ResizeMode, Video } from 'expo-av';
import MediaDraw from '../media/MediaDraw';

export default function ModalMedia({ showModal, closeModal, isVideo, imgSrc, overlay, setOverlay, disabled }) {
    const video = useRef(null);
    const [status, setStatus] = useState({});

    const changedStatus = (newStatus) => {
        setStatus(newStatus)
        if (newStatus.didJustFinish) {
            video.current.setStatusAsync({ shouldPlay: false, positionMillis: 0 })
        }
    }

    const onPress = () => {
        status.isPlaying ? video.current.pauseAsync() : video.current.playAsync()
    }

    return (
        <Modal visible={showModal} statusBarTranslucent={true} transparent={true} >
            <Center className="flex-1 bg-[#00000050]">
                <View className={`bg-secondary-50 border border-primary-900 rounded-lg p-2 justify-center items-center h-[80%] aspect-square`}>
                    <HStack className="absolute right-0 -top-10">
                        <View className="bg-primary-50 border border-primary-900 rounded-[4px] p-1">
                            <IconMC className="text-primary-900" size={24} name='close' />
                            <Pressable onPress={() => closeModal()} className="absolute w-8 h-8" />
                        </View>
                    </HStack>
                    {isVideo ?
                        <>
                            <Video ref={video} key={imgSrc} source={imgSrc} style={{ justifyContent: 'center', width: '100%', height: '100%' }} useNativeControls={false} resizeMode={ResizeMode.CONTAIN} onReadyForDisplay={videoData => {
                                videoData.srcElement.style.position = 'unset'
                            }} onPlaybackStatusUpdate={status => changedStatus(status)} />
                            <HStack space='xl' className={` absolute bottom-2 `}>
                                <Box className="rounded-full border-2 border-primary-900 bg-[#FFFFFF80]">
                                    <IconM className="text-primary-900" size={30} name='fullscreen' />
                                    <Pressable onPress={() => video.current.presentFullscreenPlayer()} className="absolute w-8 h-8" />
                                </Box>
                                <Box className="rounded-full border-2 border-primary-900 bg-[#FFFFFF80]">
                                    <IconM  className="text-primary-900" size={30} name={status.isPlaying ? 'pause' : 'play-arrow'} />
                                    <Pressable onPress={onPress} className="absolute w-8 h-8" />
                                </Box>
                            </HStack>
                        </>
                        :
                        <>
                            <Image source={imgSrc} resizeMode='cover' alt={i18n.t('global.missingImage')} className="w-full h-full" />
                            {!disabled && <MediaDraw overlay={overlay} setOverlay={setOverlay} />}
                        </>}
                </View>
            </Center>
        </Modal>
    );
}